// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  max-width: 100%;
}

.chat-gpt-main-wrapper {
  height: calc(100vh - 96px);
  width: 68%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.chat-gpt-main-wrapper.center {
  justify-content: center;
}
.chat-gpt-main-wrapper .tab-buttons-container {
  display: flex;
  justify-content: flex-start; /* Align to the left */
  gap: 10px;
}
.chat-gpt-main-wrapper .tab-buttons-container svg {
  align-self: center;
}
.chat-gpt-main-wrapper .tab-buttons-container button {
  max-width: 140px;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  border-radius: 12px;
}
@media (max-width: 768px) {
  .chat-gpt-main-wrapper .tab-buttons-container button {
    width: 100%; /* Full width for mobile */
  }
}
.chat-gpt-main-wrapper .move-to-down {
  align-self: flex-end;
}
.chat-gpt-main-wrapper .move-to-center {
  align-self: flex-center;
}
@media (max-width: 768px) {
  .chat-gpt-main-wrapper {
    width: 100%;
    padding: 10px;
  }
}

h1 {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}
@media (max-width: 576px) {
  h1 {
    font-size: 18px; /* Smaller font on very small screens */
  }
}

.tab-buttons-container .tab-buttons-container button:hover,
.chat-input-container button:hover {
  background-color: #0056b3;
  color: white;
}

/* Chat Input Container */
.chat-input-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .chat-input-container {
    flex-direction: column;
    width: 100%; /* Full width on small screens */
    padding: 10px;
  }
}

/* Chat Input */
.chat-input-container textarea {
  width: 100%; /* Ensures it fills parent */
  min-height: 50px;
  border-radius: 12px;
  padding: 10px;
  font-size: 16px;
  resize: vertical;
}
@media (max-width: 576px) {
  .chat-input-container textarea {
    font-size: 14px;
  }
}

/* Chat Button */
.chat-input-container button {
  min-width: 120px;
  padding: 12px;
  border-radius: 12px;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  text-align: center;
}
@media (max-width: 768px) {
  .chat-input-container button {
    width: 100%; /* Full width on mobile */
    margin-top: 10px;
  }
}

/* Fix for flex items */
.d-flex.gap-2 {
  display: flex;
  gap: 10px;
}
@media (max-width: 576px) {
  .d-flex.gap-2 {
    flex-direction: column;
    gap: 5px;
  }
}

/* Ensure proper alignment on small screens */
.curvy-textarea {
  width: 100%;
  border-radius: 12px;
}
@media (max-width: 576px) {
  .curvy-textarea {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ChatGpt/ChatGpt.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EAME,0BAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAJF;AALI;EACE,uBAAA;AAON;AAGE;EACA,aAAA;EACA,2BAAA,EAAA,sBAAA;EACA,SAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAII;EAVF;IAWI,WAAA,EAAA,0BAAA;EADJ;AACF;AAOE;EACE,oBAAA;AALJ;AAQE;EACE,uBAAA;AANJ;AASE;EAhDF;IAiDI,WAAA;IACA,aAAA;EANF;AACF;;AASA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AANF;AAQE;EALF;IAMI,eAAA,EAAA,uCAAA;EALF;AACF;;AAQA;;EAKE,yBAAA;EACA,YAAA;AARF;;AAWA,yBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AARF;AAUE;EANF;IAOI,sBAAA;IACA,WAAA,EAAA,gCAAA;IACA,aAAA;EAPF;AACF;;AAUA,eAAA;AACA;EACE,WAAA,EAAA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAPF;AASE;EARF;IASI,eAAA;EANF;AACF;;AASA,gBAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AANF;AAQE;EARF;IASI,WAAA,EAAA,yBAAA;IACA,gBAAA;EALF;AACF;;AAQA,uBAAA;AACA;EACE,aAAA;EACA,SAAA;AALF;AAOE;EAJF;IAKI,sBAAA;IACA,QAAA;EAJF;AACF;;AAOA,6CAAA;AACA;EACE,WAAA;EACA,mBAAA;AAJF;AAME;EAJF;IAKI,eAAA;EAHF;AACF","sourcesContent":[".chat-container {\n  max-width: 100%;\n}\n\n.chat-gpt-main-wrapper{\n  \n    &.center{\n      justify-content: center;\n    }\n\n  height:calc(100vh - 96px);\n  width: 68%;\n  margin: 0 auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n\n  .tab-buttons-container{\n  display: flex;\n  justify-content: flex-start; /* Align to the left */\n  gap: 10px;\n\n  svg{\n    align-self: center;\n  }\n\n  button {\n    max-width: 140px;\n    padding: 12px 20px;\n    border-radius: 12px;\n    font-weight: bold;\n    text-align: center;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 12px;\n  \n    @media (max-width: 768px) {\n      width: 100%; /* Full width for mobile */\n  \n    }\n  \n  }\n  }\n\n  .move-to-down{\n    align-self: flex-end;\n  }\n\n  .move-to-center{\n    align-self: flex-center;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 10px;\n  }\n}\n\nh1 {\n  font-size: 24px;\n  text-align: center;\n  margin-bottom: 20px;\n\n  @media (max-width: 576px) {\n    font-size: 18px; /* Smaller font on very small screens */\n  }\n}\n\n.tab-buttons-container \n\n/* Button hover effects */\n.tab-buttons-container button:hover,\n.chat-input-container button:hover {\n  background-color: #0056b3;\n  color: white;\n}\n\n/* Chat Input Container */\n.chat-input-container {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    width: 100%; /* Full width on small screens */\n    padding: 10px;\n  }\n}\n\n/* Chat Input */\n.chat-input-container textarea {\n  width: 100%; /* Ensures it fills parent */\n  min-height: 50px;\n  border-radius: 12px;\n  padding: 10px;\n  font-size: 16px;\n  resize: vertical;\n\n  @media (max-width: 576px) {\n    font-size: 14px;\n  }\n}\n\n/* Chat Button */\n.chat-input-container button {\n  min-width: 120px;\n  padding: 12px;\n  border-radius: 12px;\n  font-weight: bold;\n  transition: all 0.3s ease-in-out;\n  text-align: center;\n\n  @media (max-width: 768px) {\n    width: 100%; /* Full width on mobile */\n    margin-top: 10px;\n  }\n}\n\n/* Fix for flex items */\n.d-flex.gap-2 {\n  display: flex;\n  gap: 10px;\n\n  @media (max-width: 576px) {\n    flex-direction: column;\n    gap: 5px;\n  }\n}\n\n/* Ensure proper alignment on small screens */\n.curvy-textarea {\n  width: 100%;\n  border-radius: 12px;\n\n  @media (max-width: 576px) {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
